export default __webpack_public_path__ + "static/media/opex.6a7171d9.svg";